var _defs, _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAcceptIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 70",
    width: 70,
    height: 70,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h70v70h-70z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff}.b{fill:#024ad8}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a",
    d: "m0 0h70v70h-70z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m40 30.4l-7 6.6-2.9-3.1c-0.2-0.2-0.5-0.3-0.9-0.3-0.3-0.1-0.6 0.1-0.8 0.3-0.3 0.2-0.4 0.5-0.4 0.9 0 0.3 0.1 0.6 0.3 0.9l3.8 3.9q0 0.1 0.1 0.1 0.1 0.1 0.3 0.1 0.1 0.1 0.2 0.1 0.1 0 0.2 0 0.1 0 0.3 0 0.1 0 0.2 0 0.1-0.1 0.2-0.1 0.1-0.1 0.2-0.2l7.8-7.5q0.2-0.1 0.3-0.3 0.1-0.3 0.1-0.5 0-0.2-0.1-0.5-0.1-0.2-0.2-0.4-0.2-0.1-0.4-0.2-0.2-0.1-0.5-0.2-0.2 0-0.4 0.1-0.3 0.1-0.4 0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m35 20c-6.1 0-11.5 3.7-13.9 9.3-2.3 5.6-1 12 3.3 16.3 4.3 4.3 10.7 5.6 16.3 3.3 5.6-2.4 9.3-7.8 9.3-13.9 0-2-0.4-3.9-1.1-5.7-0.8-1.9-1.9-3.5-3.3-4.9-1.4-1.4-3-2.5-4.9-3.3-1.8-0.7-3.7-1.1-5.7-1.1zm0 27.6c-5.1 0-9.7-3.1-11.6-7.8-1.9-4.7-0.9-10.1 2.7-13.7 3.6-3.6 9-4.6 13.7-2.7 4.7 1.9 7.8 6.5 7.8 11.6 0 1.6-0.4 3.3-1 4.8-0.6 1.5-1.6 2.9-2.7 4.1-1.2 1.1-2.6 2.1-4.1 2.7-1.5 0.6-3.2 1-4.8 1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcceptIcon);
export default __webpack_public_path__ + "static/media/acceptIcon.d22a36b016b9300967d424379a2b80cc.svg";
export { ForwardRef as ReactComponent };